module.exports = __webpack_public_path__ + "img/SL-M-200-220.3c578e8e.svg";